import React from 'react';
import {useTranslation} from "react-i18next";
import {TourStep2} from "../../../../image";
import './CreateChainsWithinChannels.scss'

const CreateChainsWithinChannels = () => {
    const {t} = useTranslation();

    return (
        <div className="step-video-hub">
            <img src={TourStep2} width={240} height={125}/>
            <ul>
                <li>
                    {t('create_chains_within_channels_1')}
                </li>
                <li>
                    {t('create_chains_within_channels_2')}
                </li>
                <li>
                    {t('create_chains_within_channels_3')}
                </li>
            </ul>
        </div>
    );
};

export default CreateChainsWithinChannels;